import { Model } from "@/models";
import ClientAgency from "./Agency";
import ClientAgentCompanyAgentAssociation from "./AgentCompanyAgentAssociation";
import ClientAgentCompanyAssociation from "./AgentCompanyAssociation";

export default class ClientCompanyWithHierarchy extends Model {
  static type = "clientsAgentCompanyWithHierarchies";

  name!: string;
  term!: string;
  principalId?: string;

  currentAgentCompanyAgentAssociations?: ClientAgentCompanyAgentAssociation[];
  currentAgency?: ClientAgency;
  currentAgentCompanyAssociation?: ClientAgentCompanyAssociation;
}
